import * as React from "react";
import { Consumer } from "../libs/AuthContext";
import MobileHeader from "../components/MobileHeader";
import HTMLHeader from "../components/Header";
import { Grid, Icon, Segment, Loader, Dimmer, Progress} from "semantic-ui-react";
import { getLocations } from "../libs/utility";
typeof document !== `undefined` && require ("../libs/framework/colibrio-polyfill-webanimation.js");

class Book extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.pubLoader = this.props.context.pubLoader
    this.state = {
      loading: true,
      epubTitle: "",
      showSettings: false,
      showSideBar: false,
      fileName: "",
      showMenu: false,
      confirmQuit: false,
      progress: 0,
      hasNext: true,
      hasPrevious: false,
      starting: true
    }
  }
 async componentDidMount() {
    try {
      await this.pubLoader.loadFile(this.props.bookId);
      this.setState({ loading: true, fileName: this.props.bookId });
      this.view = this.pubLoader.getView();
      this.view.renderTo(this.myRef.current)
      this.view.goToStart().catch(err => {
        console.error(err);
      });
        //event listener for timelineChanged
      this.pubLoader.getView().addEngineEventListener("timelineChanged", async (evt) => {
          let viewTimeline = evt.view.getTimeline();
          if (viewTimeline) {
            await this.getPreviousLocation();
            this.onPageChange();
          }
      });
      //event listener for in-line links
      this.pubLoader.getEngine().addEngineEventListener("navigationIntent", (navigationIntentEngineEvent) => {
        navigationIntentEngineEvent.preventDefault();
        let documentLocationTarget = navigationIntentEngineEvent.readerDocumentLocationTarget;
        let internalNavigation = navigationIntentEngineEvent.internalNavigation;
        if (internalNavigation && documentLocationTarget) {
          let view = this.pubLoader.getView();
          view.goTo(documentLocationTarget).then(() => {
              this.onPageChange();
          }).catch(err => {
              console.error(err);
          });
        } else if (!internalNavigation && navigationIntentEngineEvent.href) {
          window.open(navigationIntentEngineEvent.href, "_blank");
        }
      });
       document.documentElement.addEventListener('keydown', ev => {
                let elementName = (ev.target).localName;
                let view = this.pubLoader.getView()
                if (view && !ev.defaultPrevented && (elementName !== 'textarea' && elementName !== 'input') ) {
                    if (ev.code === "ArrowRight") {
                        this.next();
                    } else if (ev.code === "ArrowLeft") {
                        this.previous();
                    }
                }
            });
      window.addEventListener("resize", this.updateDimensions);
      this.setState({ loading: false });
    }catch (e) {
      console.log(e);
    }
  }


 async getPreviousLocation ()  {
    let previousLocation = await getLocations();
    if (previousLocation && this.state.starting) {
      let filteredData = previousLocation.filter(item => item.id.includes(this.state.fileName));
      if (filteredData.length === 1) {
        let timeline = this.pubLoader.getTimeline();
        if (timeline) {
          let target = await timeline.fetchAnnotationTargetFromPosition(parseFloat(filteredData[0].location));
          this.pubLoader.getView().goTo(target)
          .then (() => {
            this.setState({
              hasNext: this.view.canPerformNext(),
              hasPrevious: this.view.canPerformPrevious(),
              starting: false
            });
          })
          .catch(err => {
            console.log(err);
          });
        }
      }
    }
  }


 previous = () => {
      if (this.view) {
          this.view = this.pubLoader.getView()
          this.view.previous()
          .then (() => {
            this.setState({
              hasNext: this.view.canPerformNext(),
              hasPrevious: this.view.canPerformPrevious()
            });
          })
          .catch(err => {
              console.log(err);
          });
      }
    this.onPageChange();
  }

 next = async () => {
      if (this.view ) {
          this.view = this.pubLoader.getView()
          this.view.next()
          .then(() => {
            this.setState({
              hasNext: this.view.canPerformNext(),
              hasPrevious: this.view.canPerformPrevious()
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
      this.onPageChange();
  }

 onPageChange () {
    this.view.refresh();
    //render timeline
    let timeline = this.pubLoader.getTimeline();
    if (timeline) {
      let length = timeline.getLength();
      let segment = timeline.getCurrentSegment();
      this.setState ({progress : ((segment.end/length)*100)})
    }
  }

 updateDimensions = () => {
    try{
      this.view = this.pubLoader.getView();
      this.view.refresh();
      this.onPageChange();
      } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <main className="book">
      <Dimmer.Dimmable dimmed={this.state.loading}>
        <Dimmer active={this.state.loading} inverted>
          <Loader>Loading</Loader>
        </Dimmer>
        <Grid style={{backgroundColor: this.pubLoader.backgroundColor, marginTop: "0.5em"}}>
          <div className="htmlHeader">
            <HTMLHeader
              {...this.props}
            />
            </div>
          <div className="mobileHeader">
            <MobileHeader
              {...this.props}
            />
            </div>
          <Grid.Row >
            <Grid.Column width={1} verticalAlign="middle" floated="right" className="tabletCol">
              {this.state.hasPrevious &&
              <Icon size="big" color={this.pubLoader.backgroundColor==="#303030" ? "grey" : "black"} name="angle left" onClick={this.previous}/>
              }
            </Grid.Column>
            {this.pubLoader.renderer === "flipbookRenderer" ?
            <Grid.Column width={12} style={{ marginTop: "5em"}} >
              <Segment className="bookPages" style={{backgroundColor: this.pubLoader.backgroundColor}}>
                <div ref={this.myRef} style={{ height: "100%"}} className="bookRenderer" id="bookRenderer"/>
              </Segment>
            </Grid.Column>
            :
            <Grid.Column width={6} style={{ marginTop: "5em"}} >
              <Segment className="bookPages" style={{backgroundColor: this.pubLoader.backgroundColor}}>
                <div ref={this.myRef} style={{ height: "100%"}} className="bookRenderer" id="bookRenderer"/>
              </Segment>
            </Grid.Column>
            }
            <Grid.Column width={1} verticalAlign="middle" floated="left" className="tabletCol">
              {this.state.hasNext &&
              <Icon size="big" color={this.pubLoader.backgroundColor==="#303030" ? "grey" : "black"} name="angle right" onClick={this.next}/>
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="smallCol">
            <Grid.Column width={1} >
              {this.state.hasPrevious &&
              <Icon size="big" color={this.pubLoader.backgroundColor==="#303030" ? "grey" : "black"} name="angle left" onClick={this.previous} style={{paddingRight: "1em"}}/>
              }
            </Grid.Column>
            <Grid.Column width={12}>
            <Progress percent={this.state.progress}
            className={this.pubLoader.backgroundColor==="#303030" ? "light" : "dark"}
            style={{width: "100%"}}>
            {Math.round(this.state.progress)}%
             </Progress>
            </Grid.Column>
            <Grid.Column width={1}>
              {this.state.hasNext &&
                <Icon size="big" color={this.pubLoader.backgroundColor==="#303030" ? "grey" : "black"} name="angle right" onClick={this.next}/>
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="tabletCol">
            <Progress percent={this.state.progress}
            className={this.pubLoader.backgroundColor==="#303030" ? "light" : "dark"}
            style={{width: "100%" }}>
            {Math.round(this.state.progress)}%
            </Progress>
          </Grid.Row>
        </Grid>
      </Dimmer.Dimmable>
      </main>
    )
  }

}

export default (props => (
  <Consumer>
    {value => <Book {...props} context={value} />}
  </Consumer>
));
